module.exports = __webpack_public_path__ + "img/map_hover_aba0acd.webp";